<span id="timer" [ngClass]="{'end': internalCounter === 0, 'nearly': internalCounter < 6 && internalCounter !== 0 }">
  {{internalCounter | displayTime}}
</span>
